import { combineReducers } from 'redux';
import { reducer as FormReducer } from 'redux-form';

import studentReducer from 'modules/Admin/redux/reducers/studentReducer';
import roomsReducer from 'modules/Admin/redux/reducers/roomsReducer';
import userDataReducer from 'modules/User/redux/userRoomsReducer';
import singleRoomReducer from 'modules/User/redux/roomReducer';

export default combineReducers({
    students: studentReducer,
    rooms: roomsReducer,
    user: userDataReducer,
    room: singleRoomReducer,
    form: FormReducer,
    extension: window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
});



// WEBPACK FOOTER //
// ./src/base/redux/rootReducer.js